export default __webpack_public_path__ + "404_page-vQh.jpg";